module.exports = __webpack_public_path__ + "img/slide05.f6926553.jpg";